import React, { useState } from 'react';
import axios from 'axios';

function Commissions() {
    const [items, setItems] = useState([]);
    const [error, setError] = useState('');
    const [formData, setFormData] = useState({
        related_invoice_id: '',
        related_offer_id: '',
        related_object_id: '',
        beneficiary_name: '',
        beneficiary_role: '',
        payout_type: 'percentage',
        percentage_value: '',
        fixed_amount: '',
        base_amount: '',
        payout_amount: '',
        contract_type: 'invoice',
        status: 'planned',
        notes: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post('http://127.0.0.1:8010/api/commission-payouts', formData);
            setItems((prev) => [...prev, response.data]);
            setError('');
        } catch (err) {
            setError('Provision konnte nicht gespeichert werden.');
        }
    };

    return (
        <div>
            <h1>Provisionen</h1>

            <form onSubmit={handleSubmit}>
                <input type="number" name="related_invoice_id" placeholder="Rechnungsbezug" onChange={handleChange} />
                <input type="number" name="related_offer_id" placeholder="Angebotsbezug" onChange={handleChange} />
                <input type="number" name="related_object_id" placeholder="Objektbezug" onChange={handleChange} />
                <input type="text" name="beneficiary_name" placeholder="Begünstigter Name" onChange={handleChange} />
                <input type="text" name="beneficiary_role" placeholder="Rolle" onChange={handleChange} />
                <select name="payout_type" onChange={handleChange}>
                    <option value="percentage">Prozent-Provision</option>
                    <option value="fixed">Feste Provision</option>
                </select>
                <input type="number" name="percentage_value" placeholder="Prozentsatz" onChange={handleChange} />
                <input type="number" name="fixed_amount" placeholder="Fester Betrag" onChange={handleChange} />
                <input type="number" name="base_amount" placeholder="Basisbetrag" onChange={handleChange} />
                <input type="number" name="payout_amount" placeholder="Auszahlungsbetrag" onChange={handleChange} />
                <select name="contract_type" onChange={handleChange}>
                    <option value="invoice">Rechnung</option>
                    <option value="commission_agreement">Provisionsvertrag</option>
                </select>
                <input type="text" name="status" placeholder="Status" onChange={handleChange} />
                <textarea name="notes" placeholder="Notizen" onChange={handleChange} />
                <button type="submit">Provision speichern</button>
            </form>

            {error && <p className="error">{error}</p>}

            <table>
                <thead>
                    <tr>
                        <th>Begünstigter</th>
                        <th>Rolle</th>
                        <th>Typ</th>
                        <th>Auszahlung</th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item, index) => (
                        <tr key={item.id || index}>
                            <td>{item.beneficiary_name}</td>
                            <td>{item.beneficiary_role}</td>
                            <td>{item.payout_type}</td>
                            <td>{item.payout_amount}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default Commissions;
